import { DatiUIU } from './../model/dati-uiu.model';
import { PrintModalComponent } from './../shared/print-modal/print-modal.component';
import { Polygon } from '../model/polygon.model';
import { FloorPlan } from '../model/floorplan.model';
import { MsgSeverities } from './../services/message.service';
import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import { MsgService } from 'src/app/services/message.service';
import { PrintService } from '../services/print.service';
import { AppState } from '../app.state';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/dynamicdialog';
import { polygonColors } from '../shared/utils';

@Component({
  selector: 'app-svg-editor',
  templateUrl: './svg-editor.component.html',
  styleUrls: ['./svg-editor.component.scss']
})
export class SvgEditorComponent implements OnInit, OnDestroy {
  
  @Input() selectFile: Subject<string> = new Subject();
  @Input() toolEvent: Subject<string> = new Subject();
  @Input() rowSelection: Subject<Polygon> = new Subject();

  @Output() imageLoaded: EventEmitter<boolean> = new EventEmitter();
  @Output() selectionChanged: EventEmitter<string> = new EventEmitter();
  @Output() polygonResized: EventEmitter<[number, number][]> = new EventEmitter();
  @Output() polygonAdded: EventEmitter<[number, number][]> = new EventEmitter();
  @Output() rectAdded: EventEmitter<[number, number][]> = new EventEmitter();
  @Output() deleteElements: EventEmitter<string[]> = new EventEmitter();
  @Output() undoDelete: EventEmitter<string[]> = new EventEmitter();
  @Output() undoCreate: EventEmitter<string[]> = new EventEmitter();
  @Output() undoResizeMove: EventEmitter<string[]> = new EventEmitter();
  @Output() undoAssignDict: EventEmitter<string[]> = new EventEmitter();
  @Output() redoCreate: EventEmitter<string[]> = new EventEmitter();
  @Output() redoResizeMove: EventEmitter<string[]> = new EventEmitter();
  @Output() redoAssignDict: EventEmitter<string[]> = new EventEmitter();
  @Output() selectedTool: EventEmitter<string> = new EventEmitter();

  subscriptions: Subscription[] = [];
  methodDraw: any;
  undoManager: any;
  planimetrie: string;
  filename: string;
  datiUIU: DatiUIU;
  plan: FloorPlan;
  image: any;
  printOpts: any;
  imgSize: [number, number];


  square: Function = () => {
    this.methodDraw.canvas.setMode('rect');
  }

  select: Function = () => {
    this.methodDraw.canvas.setMode('select');
    this.selectedTool.emit('select');
  }

  zoomIn: Function = () => {
    this.methodDraw.canvas.setMode('zoom');
  }

  zoomOut: Function = () => {
    this.methodDraw.canvas.setMode('zoomOut');
  }

  zoomPan: Function = () => {
    this.methodDraw.canvas.setMode('zoomPan');
  }

  zoomSelect: Function = () => {
    this.methodDraw.canvas.setMode('zoomSelect');
  }

  drawPolygon: Function = () => {
    this.methodDraw.canvas.setMode('path');
  }

  addNode: Function = () => {
    this.methodDraw.addNode();
    const elemId = document.getElementById('resizePolygon').getAttribute('value');
    const elem = document.getElementById(elemId);
    this.methodDraw.canvas.pathActions.select(elem);
  }

  deleteNode: Function = () => {
    this.methodDraw.deleteNode();
  }

  editPolygon: Function = () => {
    const selElements = this.methodDraw.canvas.getSelectedElems();
    switch (selElements.length) {
      case 0:
        this.msgService.showMsg(MsgSeverities.WARNING, 'Attenzione', 'Selezionare un elemento della planimetria');
        break;
      case 1:
        if (!selElements[0]) {
          this.msgService.showMsg(MsgSeverities.WARNING, 'Attenzione', 'Selezionare un elemento della planimetria');
        } else {
          this.methodDraw.canvas.pathActions.select(selElements[0]);
          this.methodDraw.canvas.pathActions.select(selElements[0]);
        }
        break;
      default:
        this.msgService.showMsg(MsgSeverities.WARNING, 'Attenzione', 'Selezionare un unico elemento della planimetria');
        break;
    }
  }

  restoreZoom: Function = () => {
    this.methodDraw.changeZoom({value: 35});
  }

  deleteSelected: Function = () => {
    const ids = [];
    const elems = this.methodDraw.canvas.getSelectedElems();
    if (elems && elems.length > 0 && elems[0]) {
      elems.forEach(elem => {
        ids.push(elem.id);
      });
      this.methodDraw.deleteSelected();
      this.deleteElements.emit(ids);
    }
  }

  undo: Function = () => {
    const lastAction = this.undoManager.undoStack[this.undoManager.undoStackPointer - 1]; 
    if (!lastAction) {
      return;
    }
    const elementsIds = lastAction.elements().map(val => val.id);
    switch (lastAction.text) {
      case 'Delete Elements':
        this.undoDelete.emit(elementsIds);
        this.methodDraw.undo();
        break;
      case 'Create path':
      case 'Create rect':
        this.undoCreate.emit(elementsIds);
        this.methodDraw.undo();
        break;
      case 'size':
      case 'position':
      case 'Change path Move path point(s)':
        this.undoResizeMove.emit(elementsIds);
        this.methodDraw.undo();
        break;
      case 'Change stroke':
        this.undoAssignDict.emit(elementsIds);
        this.methodDraw.undo();
        this.undo();
        break;
      case 'Change fill':
        this.methodDraw.undo();
        break;
      case 'Change stroke-dasharray':
        this.methodDraw.undo();
        this.undo();
        break;
    }
  }

  redo: Function = () => {
    let lastAction;
    if (this.undoManager.undoStackPointer < this.undoManager.undoStack.length && this.undoManager.undoStack.length > 0) {
      lastAction = this.undoManager.undoStack[this.undoManager.undoStackPointer]; 
    } else {
      return;
    }
    const elementsIds = lastAction.elements().map(val => val.id);
    switch (lastAction.text) {
      case 'Delete Elements':
        this.deleteElements.emit(elementsIds);
        this.methodDraw.redo();
        break;
      case 'Create path':
      case 'Create rect':
        const points = [];
        let elem;
        this.undoManager.undoStack.forEach(val => {
          if (val && val.text.indexOf('Create') !== -1) {
            elem = val.elem;
          }
        })
        for (let i = 0; i < elem.pathSegList.numberOfItems - 1; i++) {
          points.push([elem.pathSegList.getItem(i).x, elem.pathSegList.getItem(i).y]);
        }
        this.polygonAdded.emit(points);
        this.methodDraw.redo();
        break;
      case 'size':
      case 'position':
      case 'Change path Move path point(s)':
        this.redoResizeMove.emit(elementsIds);
        this.methodDraw.redo();
        break;
      case 'Change fill':
        this.redoAssignDict.emit(elementsIds);
        this.methodDraw.redo();
        this.redo();
        break;
      case 'Change stroke':
        this.methodDraw.redo();
        break;
      case 'Change stroke-dasharray':
        this.methodDraw.redo();
        this.redo();
        break;
    }
  }

  save: Function = () => {
    this.savePlan();
  }

  print: Function = () => {
    this.printPlan();
  }

  constructor(
    private msgService: MsgService,
    private printService: PrintService,
    private store: Store<AppState>,
    private dialogService: DialogService
  ) { 
    this.planimetrie = localStorage.getItem('planimetrie');
  }

  ngOnInit() {
    this.methodDraw = window['methodDraw'];

    this.methodDraw.init();

    this.subscriptions.push(
      this.selectFile.subscribe((filename: string) => {
        if (filename) {
          this.filename = filename;
        }
      })
    );

    this.store.select('datiUIU').subscribe((val: DatiUIU) => {
      if (val) {
        this.datiUIU = val;
      }
    });

    this.subscriptions.push(
      this.store.select('image').subscribe((val: any) => {
        if (val && val.image && val.image.byteLength > 0) {
          const b = new Blob([new Uint8Array(val.image).buffer]);
          const f = new File([b], 'test.png', {type: "image/png"});
          const reader = new FileReader();
          reader.onloadend = (e) => {
            this.methodDraw.curConfig.baseImg = e.target.result;
            const img = new Image();
            img.onload = (elem: any) => {
              if (elem && elem.srcElement) {
                const tmpImage = elem.srcElement;
                this.methodDraw.curConfig.dimensions = [tmpImage.width, tmpImage.height];
                this.imgSize = [tmpImage.width, tmpImage.height];
              }
              this.methodDraw.clear();
              this.methodDraw.addImage(f);
              // document.getElementById('svgcanvas').style['max-height'] = 
              // document.getElementById('svgcanvas').style.height = this.canvasHeight + 'px';
              const sizePerc = (window.innerHeight/100) * 14.87;
              document.getElementById('workarea').style.height = window.innerHeight - sizePerc + 'px';
              this.methodDraw.changeZoom({value: 45});
              this.undoManager = this.methodDraw.canvas.undoMgr;
              this.undoManager.resetUndoStack();
              this.loadPolygons();
              this.imageLoaded.emit(true);
              this.select();
              window.onresize = () => {
                // this.methodDraw.updateCanvas();
                // document.getElementById('svgcanvas').style['max-height'] = 
                // document.getElementById('svgcanvas').style.height = window.innerHeight - 94.23 + 'px';
                const sizePerc = (window.innerHeight/100) * 14.87;
                document.getElementById('workarea').style.height = window.innerHeight - sizePerc + 'px';
              }
            }
            img.src = e.target.result.toString();
            this.image = e.target.result.toString();
          }
          reader.readAsDataURL(b);
        }
      })
    );

    this.subscriptions.push(
      this.toolEvent.subscribe(val => {
        if (val && this[val]) {
          this[val]();
        }
      })
    );

    this.subscriptions.push(
      this.rowSelection.subscribe((val: any) => {
        if (val && val.polygon) {
          this.methodDraw.canvas.clearSelection();
          const polySvg = document.getElementById(val.polygon.id);
          if (val.selected) {
            this.methodDraw.canvas.addToSelection([polySvg]);
          } else {
            this.methodDraw.canvas.removeFromSelection([polySvg]);
          }
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      if (sub) {
        sub.unsubscribe();
      }
    });
  }

  loadPolygons() {
    this.subscriptions.push(
      this.store.select('floorPlan').subscribe((plan: FloorPlan) => {
        this.plan = plan;
        if (plan.poligono) {
          plan.poligono.forEach((poly: Polygon, idx: number) => {
            let color = '';
            const roomsExt = poly.rooms ? poly.rooms.find(val => typeof val === 'string' && val.indexOf('external') !== -1) : undefined;
            if (!roomsExt) {
              if (poly.normalized && poly.normalized.length > 0) {
                color = polygonColors.green;
              } else {
                if (roomsExt) {
                  color = polygonColors.yellow;
                } else {
                  color = polygonColors.blue;
                }
              }
              let svgPathD = '';
              for (let i = 0; i < poly.contour.length; i++) {
                const point = poly.contour[i];
                if (i === 0) {
                  svgPathD += 'M ' + point[0] + ',' + point[1];
                  continue;
                }
                if (i > 0 && i < poly.contour.length) {
                  svgPathD += ' L ' + point[0] + ',' + point[1];
                  continue;
                }
              }
              svgPathD += ' L ' + poly.contour[0][0] + ',' + poly.contour[0][1] + ' Z';
              this.methodDraw.canvas.addSvgElementFromJson({
                "element": "path",
                "attr": {
                  "d": svgPathD,
                  "id": 'polygon_' + idx,
                  "stroke": color,
                  "fill": color,
                  "fill-opacity": 0.25,
                  "stroke-width": 2.5,
                  "style": "pointer-events: all"
                }
              });

              if (roomsExt) {
                this.methodDraw.canvas.moveElementToBottom('polygon_' + idx)
              }
            }
          });
        }
      })
    );
  }

  changeSvgSelection(evt) {
    const elems = this.methodDraw.canvas.getSelectedElems();
    if (elems && elems.length > 0 && elems[0]) {
      this.selectionChanged.emit(elems[0].id);
    } else {
      this.selectionChanged.emit(undefined);
    }
  }

  resizePolygon(evt) {
    const points = [];
    const elem = this.methodDraw.canvas.getElem(evt.srcElement.value);
    for (let i = 0; i < elem.pathSegList.numberOfItems - 1; i++) {
      points.push([elem.pathSegList.getItem(i).x, elem.pathSegList.getItem(i).y]);
    }
    this.polygonResized.emit(points);
  }

  addPolygon(evt) {
    const points = [];
    const elem = this.methodDraw.canvas.getElem(evt.srcElement.value);
    for (let i = 0; i < elem.pathSegList.numberOfItems - 1; i++) {
      points.push([elem.pathSegList.getItem(i).x, elem.pathSegList.getItem(i).y]);
    }
    this.methodDraw.canvas.clearSelection();
    this.methodDraw.canvas.addToSelection([elem]);
    this.methodDraw.deleteSelected();
    let svgPathD = '';
    for (let i = 0; i < points.length; i++) {
      const point = points[i];
      if (i === 0) {
        svgPathD += 'M ' + point[0] + ',' + point[1];
        continue;
      }
      if (i > 0 && i < points.length) {
        svgPathD += ' L ' + point[0] + ',' + point[1];
        continue;
      }
    }
    svgPathD += ' L ' + points[0][0] + ',' + points[0][1] + ' Z';
    this.methodDraw.canvas.addSvgElementFromJson({
      "element": "path",
      "attr": {
        "d": svgPathD,
        "id": elem.id,
        "stroke": polygonColors.blue,
        "fill": polygonColors.blue,
        "fill-opacity": 0.25,
        "stroke-width": 2.5,
        "style": "pointer-events: all"
      }
    });
    this.polygonAdded.emit(points);
    this.methodDraw.canvas.setMode('select');
    setTimeout(() => {
      this.methodDraw.canvas.setMode('path');
    }, 100);
  }

  addRect(evt) {
    const points = [];
    const elem = this.methodDraw.canvas.getElem(evt.srcElement.value);
    const rectElem = elem.getBBox();
    points.push([rectElem.x, rectElem.y]);
    points.push([rectElem.x + rectElem.width, rectElem.y]);
    points.push([rectElem.x + rectElem.width, rectElem.y + rectElem.height]);
    points.push([rectElem.x, rectElem.y + rectElem.height]);
    this.methodDraw.canvas.clearSelection();
    this.methodDraw.canvas.addToSelection([elem]);
    this.methodDraw.deleteSelected();
    let svgPathD = '';
    for (let i = 0; i < points.length; i++) {
      const point = points[i];
      if (i === 0) {
        svgPathD += 'M ' + point[0] + ',' + point[1];
        continue;
      }
      if (i > 0 && i < points.length) {
        svgPathD += ' L ' + point[0] + ',' + point[1];
        continue;
      }
    }
    svgPathD += ' L ' + points[0][0] + ',' + points[0][1] + ' Z';
    this.methodDraw.canvas.addSvgElementFromJson({
      "element": "path",
      "attr": {
        "d": svgPathD,
        "id": elem.id,
        "stroke": polygonColors.blue,
        "fill": polygonColors.blue,
        "fill-opacity": 0.25,
        "stroke-width": 2.5,
        "style": "pointer-events: all"
      }
    });
    this.rectAdded.emit(points);
    this.methodDraw.canvas.setMode('select');
    setTimeout(() => {
      this.methodDraw.canvas.setMode('rect');
    }, 100);
  }

  exportRaster(evt) {
    const imgSrc = evt.srcElement.value;
    const today = new Date();
          const downloadName = 
          this.filename + '_' + 
            today.getDate() + '-' + 
            (today.getMonth() + 1) + '-' + 
            today.getFullYear();
    const data = this.printOpts.data ? this.datiUIU : undefined;
    const table = this.printOpts.table ? this.plan.poligono : undefined;
    this.printService.getPDF(downloadName, this.imgSize, imgSrc, data, table);
  }

  delKeypress(evt) {
    const ids = [];
    const elems = this.methodDraw.canvas.getSelectedElems();
    if (elems && elems.length > 0 && elems[0]) {
      elems.forEach(elem => {
        ids.push(elem.id);
      });
      this.deleteElements.emit(ids);
    }
  }

  selectMode(evt) {
    this.selectedTool.emit('select');
  }

  printPlan() {
    const ref = this.dialogService.open(PrintModalComponent, {
      header: 'Impostazioni di stampa',
      width: '20%'
    });
    ref.onClose.subscribe(opts => {
      if (opts) {
        this.printOpts = opts;
        if (!opts.polygons) {
          const today = new Date();
          const downloadName = 
          this.filename + '_' + 
            today.getDate() + '-' + 
            (today.getMonth() + 1) + '-' + 
            today.getFullYear();
          const data = opts.data ? this.datiUIU : undefined;
          const table = opts.table ? this.plan.poligono : undefined;
          this.printService.getPDF(downloadName, this.imgSize, undefined, data, table);
        } else {
          this.methodDraw.exportImage();
        }
      }
    });
  }

  savePlan() {
    this.msgService.showMsg(MsgSeverities.SUCCESS, 'Info', 'Salvataggio effettuato correttamente', false);
  }
}
